<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Szeretnéd kézzel kitölteni a bankszámla adatait?</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>Ezután nem fogjuk frissíteni a DNB-ből.</ng-template>
</payee-popup>
